import { all, fork, put, takeEvery } from "redux-saga/effects";
import {
    GET_MENU_MERCHANT_DATA,
    GET_MENU_MERCHANT_DATA_SUCCESS,
    GET_MENU_MERCHANT_DATA_FAILED
} from "../../constants/ActionTypes";
import { menuMerchantApi } from "../api/Menu";
import { apiHandler } from "./handler";

function* fetchMenuMerchant({ payload }) {
    const { ok, data, message } = yield* apiHandler(menuMerchantApi, payload);

    if (ok) {
        if (data && data.menu) {
            localStorage.setItem("menuMerchant", JSON.stringify(data.menu));
        }

        yield put({
            type: GET_MENU_MERCHANT_DATA_SUCCESS,
            payload: data
        });
    } else {
        yield put({
            type: GET_MENU_MERCHANT_DATA_FAILED,
            payload: message
        });
    }
}

export function* getMenuMerchantData() {
    yield takeEvery(GET_MENU_MERCHANT_DATA, fetchMenuMerchant);
}

// yield all
export default function* rootSaga() {
    yield all([fork(getMenuMerchantData)]);
}
